import { Card, Col, Grid, Text } from '@mantine/core';
import React from 'react';
import { Helmet } from 'react-helmet'
import Layout from '../../Layout/Layout';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import faker from 'faker';
import randomColor from 'randomcolor';
import CountUp from 'react-countup';

const Dashboard = ({ title }) => {

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            title: {
                display: true,
                text: 'Jobs Completed Monthly',
            },
        },
    };

    const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'Deceember'];

    const data = {
        labels,
        datasets: [
            {
                label: 'Months',
                data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
                backgroundColor: randomColor({
                    format: 'rgba',
                    count: 12,
                    luminosity: 'dark'
                }),
                borderRadius: 8
            },
        ],
    };


    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
            </Helmet>
            <Layout activeKey={0}>
                <Grid>
                    <Col span={4}>
                        <Card padding='xl' shadow="sm" radius="md">
                            <Text size='xl' align='center' weight={700}>
                                <CountUp
                                    start={0}
                                    end={51}
                                    separator=","
                                    duration={2.75}
                                />{" "}
                            </Text>
                            <Text size='lg' align='center'>Ongoing Jobs</Text>
                        </Card>
                    </Col>
                    <Col span={4}>
                        <Card padding='xl' shadow="sm" radius="md">
                            <Text size='xl' align='center' weight={700}> <CountUp
                                start={0}
                                end={354}
                                separator=","
                                duration={1}
                            />{" "}</Text>
                            <Text size='lg' align='center'>Jobs this month</Text>
                        </Card>
                    </Col>
                    <Col span={4}>
                        <Card padding='xl' shadow="sm" radius="md">
                            <Text size='xl' align='center' weight={700}> <CountUp
                                start={0}
                                end={3255}
                                separator=","
                                duration={.25}
                            />{" "}</Text>
                            <Text size='lg' align='center'>All time jobs</Text>
                        </Card>
                    </Col>
                </Grid>
                <Grid>
                    <Col span={12}>
                        <Card shadow="sm" radius="md">
                            <Bar options={options} data={data} />
                        </Card>
                    </Col>
                </Grid>
            </Layout>
        </>
    )
}

export default Dashboard
